import { dynamicSort } from '@/shared/utils/dynamicSort';
import angular from 'angular';
import moment from 'moment';
import AuthService, { functionalities, privileges } from '@/shared/services/AuthService';

angular
  .module('cloudX')
  .controller('EmployeeDetailCtrl', [
    'employee',
    'resourceFactorySvc',
    'flySvc',
    '$filter',
    '$q',
    '$state',
    'dataCache',
    'appSettings',
    'ModalService',
    '$http',
    'appUrls',
    '$translate',
    'dialogsSvc',
    'licensingSvc',
    'authService',
    'enumCacheSvc',
    employeeDetailCtrl,
  ]);

function employeeDetailCtrl(
  employee,
  resourceFactorySvc,
  flySvc,
  $filter,
  $q,
  $state,
  dataCache,
  appSettings,
  ModalService,
  $http,
  appUrls,
  $translate,
  dialogsSvc,
  licensingSvc,
  authService,
  enumCacheSvc,
) {
  var vm = this;
  var auth = authService.getClaims();
  vm.su = auth.su || 0;
  vm.errors = {};
  vm.userRoles = [];
  vm.licenseInfo = licensingSvc.getLicenseInformation();
  vm.currentEmployee = dataCache.getArray('employee').employeeID;
  vm.usesSso = (dataCache.getArray('ssoProvider') || 0) > 0;
  vm.signInMethods = [
    { value: false, label: 'SSO' },
    { value: true, label: $translate.instant('Username/password') },
  ];
  vm.employeeProfiles = employee.employeeProfiles.map(x => ({
    ...x,
    name: x.isDefault ? `${x.name} 🟊` : x.name,
  }));
  vm.timeTable = null;
  vm.overtimeRemaining = null;
  vm.canGenerateInsightReport =
    AuthService.hasFeature('AI') &&
    AuthService.hasPermission({ functionality: functionalities.AI, privilege: privileges.Read }) &&
    AuthService.hasPermission({
      functionality: functionalities.RegistrationOthers,
      privilege: privileges.Read,
    }) &&
    AuthService.hasPermission({ functionality: functionalities.Users, privilege: privileges.Read });
  if (!vm.licenseInfo || Object.keys(vm.licenseInfo).length === 0) {
    licensingSvc.reloadLicenseInformation().then(info => {
      vm.licenseInfo = info;
    });
  }
  vm.setEmployee = function(e) {
    vm.employee = { ...e };
    if (vm.employee.userID === '00000000-0000-0000-0000-000000000000') vm.employee.userID = null;
    if (typeof vm.employee.employeeStartDate === 'string')
      vm.employee.employeeStartDate = new Date(vm.employee.employeeStartDate);
    if (typeof vm.employee.employeeEndDate === 'string')
      vm.employee.employeeEndDate = new Date(vm.employee.employeeEndDate);
    vm.userRole =
      vm.employee.userRoles && vm.employee.userRoles.length ? vm.employee.userRoles[0] : null;
    if (vm.employee.license && vm.employee.license.isTemporary) {
      vm.employee.license.beginDate = moment(vm.employee.license.beginDate).toDate();
      vm.employee.license.endDate = moment(vm.employee.license.endDate).toDate();
      vm.employee.license.beginDateWarning = vm.employee.license.beginDate > new Date();
      vm.employee.license.endDateWarning = vm.employee.license.endDate < new Date();
    }
  };

  vm.setEmployee(employee);

  vm.select = function(employee) {
    $state.go('employees.detail', {
      id: employee.employeeID,
    });
  };

  var resource = resourceFactorySvc.get('employee');

  var handleEmployeeResponse = function(data) {
    vm.setEmployee(data);

    // Keep the cached current-user employee in sync when the user edits their own record.
    // Merge in place (angular.extend, not reassign) so controllers/directives that hold the
    // cached object by reference (regOverviewCtrl, draftInvoiceRowDrv, menuDrv, ...) stay valid.
    if (data.employeeID === vm.currentEmployee) {
      angular.extend(dataCache.getArray('employee'), data);
    }

    licensingSvc.reloadLicenseInformation();

    flySvc.success('msgConfirmChange');
  };

  vm.submit = function(newValue, field) {
    if (typeof newValue === 'undefined') {
      if (vm.errors) {
        for (var error in vm.errors) {
          if (vm.errors.hasOwnProperty(error) && error[0] !== '$') {
            if (vm.errors[error].code) {
              flySvc.error(
                vm.errors[error].code,
                vm.errors[error].code === 3000
                  ? [field]
                  : angular.copy(vm.errors[error].parameters),
              );
            }
          }
        }
      }
      return '';
    }
    if (field === 'userRole') {
      field = 'userRoles';
      newValue = newValue != null ? [newValue] : [];
    }
    if (field === 'employeeProfileId' && newValue) {
      newValue = newValue.id;
    }

    if (field === 'workDayStartHour' || field === 'workDayEndHour') {
      var date = moment(newValue, 'HH:mm:ss');
      if (!date.isValid()) return '';
    }

    // if value hasn't changed: return
    if (angular.equals(vm.employee[field], newValue)) return false;

    // try and save (a copy of) the emp with the new value...
    var empToSave = angular.copy(vm.employee);
    // user is a special case: the whole userObject is replaced.
    empToSave[field] = newValue;
    return resource.update(empToSave, handleEmployeeResponse, function(error) {
      flySvc.error(error.data.code, error.data.parameters);
      return '';
    }).$promise;
  };

  vm.resetTwoFa = function() {
    dialogsSvc.showYesNo('msgConfirmResetTwoFaTitle', 'msgConfirmResetTwoFa').then(function() {
      vm.resettingTwoFa = true;
      $http.post(appUrls.api + '/api/user/ResetTwoFa/' + vm.employee.userID).then(
        function() {
          vm.resettingTwoFa = false;
          vm.employee.twoFaEnabled = false;
          flySvc.success('msgConfirmChange');
        },
        function(error) {
          vm.resettingTwoFa = false;
          flySvc.error(error.data.code, error.data.parameters);
        },
      );
    });
  };

  vm.saveEmployeeTeams = function(data) {
    return resource.updateTeams(
      { id: vm.employee.employeeID },
      data,
      function(response) {
        if (response) {
          vm.employee.teams = response;
        }
        flySvc.success('msgConfirmChange');
      },
      function(error) {
        flySvc.error(error.data.code, error.data.parameters);
        return '';
      },
    ).$promise;
  };

  vm.saveEmployeeTags = function(data) {
    return resource.updateTags(
      { id: vm.employee.employeeID },
      data,
      function(response) {
        flySvc.success('msgConfirmChange');
        return response;
      },
      function(error) {
        flySvc.error(error.data.code, error.data.parameters);
        return '';
      },
    ).$promise;
  };

  var saveUser = function(data) {
    if (data && data.userEmail) {
      var empToSave = angular.copy(vm.employee);
      angular.extend(empToSave, data);
      return resource.update(empToSave, handleEmployeeResponse).$promise;
    }
    return $q.when(true);
  };

  vm.updateInternalPrice = function(internalPrice) {
    if (vm.employee.internalPrice === internalPrice) return false;

    return dialogsSvc.updateInternalPrice(internalPrice).then(
      function(result) {
        if (!result) return false;

        result.employeeId = vm.employee.employeeID;

        $http.put(appUrls.api + '/api/employee/updateInternalPrice', result).then(
          function(result) {
            flySvc.success();
            return true;
          },
          function(error) {
            flySvc.error(error.data.code, error.data.parameters);
            return '';
          },
        );
      },
      function(error) {
        return false;
      },
    );
  };

  vm.addUser = function() {
    ModalService.showModal({
      template: require('../dialogs/createUserProfileDialog.html'),
      controller: 'CreateUserProfileDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        employee: angular.copy(vm.employee),
        save: saveUser,
      },
    }).then(function(modal) {
      modal.element.modal();
      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e); //Remove event
        modal.element.remove(); //Remove element
      });
    });
  };
  vm.deleteEmployee = function() {
    if (!vm.employee.isActive) return;

    ModalService.showModal({
      template: require('../dialogs/deleteEmployeeDialog.html'),
      controller: 'DeleteEmployeeDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        employeeId: vm.employee.employeeID,
        userId: vm.employee.userID,
      },
    }).then(function(modal) {
      modal.element.modal();
      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e); //Remove event
        modal.element.remove(); //Remove element
      });
      modal.close.then(function(result) {
        if (!result) return;
        angular.extend(vm.employee, result);
      });
    });
  };
  vm.undeleteEmployee = function() {
    if (vm.employee.isActive) return;
    ModalService.showModal({
      template: require('../dialogs/undeleteEmployeeDialog.html'),
      controller: 'UndeleteEmployeeDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        employeeId: vm.employee.employeeID,
      },
    }).then(function(modal) {
      modal.element.modal();
      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e); //Remove event
        modal.element.remove(); //Remove element
      });
      modal.close.then(function(result) {
        if (result) {
          flySvc.success('msgEmployeeRestoreSuccesful');
          angular.extend(vm.employee, result);
        }
      });
    });
  };
  vm.deleteTimeTable = function() {
    dialogsSvc.showYesNo('msgConfirmDeleteTitle', 'msgConfirmDeleteTimeTable').then(function() {
      $http.delete(`${appUrls.api}/api/employee/TimeTable/${vm.employee.employeeID}`).then(() => {
        vm.timeTable = null;
      });
    });
  };

  $http.get(`${appUrls.api}/api/employee/TimeTable/${vm.employee.employeeID}`).then(({ data }) => {
    if (data) {
      vm.timeTable = data;
      $http
        .get(`${appUrls.api}/api/employee/OvertimeRemaining/${vm.employee.employeeID}`)
        .then(({ data: overtime }) => {
          vm.overtimeRemaining = overtime;
        });
    } else {
      vm.timeTable = null;
      vm.overtimeRemaining = null;
    }
  });

  vm.editTimeTable = function() {
    ModalService.showModal({
      template: require('../dialogs/employeeTimeTableDialog.html'),
      controller: 'EmployeeTimeTableDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        employee: vm.employee,
        timeTable: vm.timeTable,
      },
    }).then(function(modal) {
      modal.element.modal();
      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e); //Remove event
        modal.element.remove(); //Remove element
      });
      modal.close.then(function(result) {
        if (result) {
          vm.timeTable = result;
        }
      });
    });
  };
  vm.editOvertime = function() {
    ModalService.showModal({
      template: require('../dialogs/employeeOvertimeDialog.html'),
      controller: 'EmployeeOvertimeDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        employee: vm.employee,
      },
    }).then(function(modal) {
      modal.element.modal();
      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e); //Remove event
        modal.element.remove(); //Remove element
      });
      modal.close.then(function(result) {
        if (result !== null) {
          vm.overtimeRemaining = result;
        }
      });
    });
  };
  vm.openInsightModal = function() {
    ModalService.showModal({
      template: require('../dialogs/employeeInsightDialog.html'),
      controller: 'EmployeeInsightDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        employeeId: vm.employee.employeeID,
      },
    }).then(function(modal) {
      modal.element.modal();
      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e);
        modal.element.remove();
      });
    });
  };

  vm.translateEmailRemark = function() {
    if (!vm.employee?.userID) return;
    dialogsSvc
      .translateListItem('useremailremark', vm.employee.userID, '', {
        inputRows: 7,
        defaultRequired: false,
        maxlength: 500,
      })
      .then(function(result) {
        if (result) {
          //This is a special case for the translations.
          //If we use the default as fallback, you can't leave another language empty.
          flySvc.success();
        }
      });
  };
  $q.all([$http.get(`${appUrls.api}/api/TenantRole`), enumCacheSvc.get('role')]).then(
    ([{ data: tenantRoles }, defaultRoles]) => {
      vm.userRoles = [
        ...defaultRoles
          .map(x => ({
            role: x.key,
            label: $filter('translateList')(x.key, 'role', x.value),
            customRoleId: null,
            customRoleName: null,
            group: $translate.instant('DefaultRoles'),
          }))
          .sort(dynamicSort('role')),
        ...(tenantRoles || [])
          .map(x => ({
            role: 99,
            label: x.name,
            customRoleId: x.id,
            customRoleName: x.name,
            group: $translate.instant('CustomRoles'),
          }))
          .sort(dynamicSort('label')),
      ];
      if (vm.userRole) {
        vm.userRole = vm.userRoles.find(
          x =>
            x.role === vm.userRole.role &&
            (x.role != 99 || x.customRoleId == vm.userRole.customRoleId),
        );
      }
    },
  );
}
